/* eslint-disable import/prefer-default-export */

export const containerClass = (contentType, componentType) => {
  if (contentType) {
    return `c-${contentType}__${componentType}`;
  }
  return '';
};
